module.exports = __webpack_public_path__ + "img/plus.59b2df33.svg";